import { IAppState } from '~/shared/store/types'
import {
  selectUserCountryCode,
  selectUserUtmTags,
} from '~/shared/store/user/selects'

import { getPurchaseCommonEventParams } from './getPurchaseCommonEventParams'

export const getPurchaseSuccessEventParams = (state: IAppState) => {
  const {
    email,
    productId,
    price,
    trialPrice,
    uuid,
    currency,
    periodName,
    periodQuantity,
    screenName,
    stripeAccountName,
    stripeAccountId,
  } = getPurchaseCommonEventParams(state)

  const utmTags = selectUserUtmTags(state)
  const countryCode = selectUserCountryCode(state)

  return {
    email,
    productId,
    price,
    trialPrice,
    uuid,
    currency,
    periodName,
    periodQuantity,
    screenName,
    stripeAccountName,
    stripeAccountId,
    utmTags,
    countryCode,
  }
}
